var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Proposed-MVP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid-Menu",
    transform: "translate(-56.000000, -64.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(40.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75,26 C20.1266474,26 18,28.1266474 18,30.75 C18,33.3733526 20.1266474,35.5 22.75,35.5 C25.3733526,35.5 27.5,33.3733526 27.5,30.75 C27.5,28.1266474 25.3733526,26 22.75,26 Z M28.1777882,34.7634068 L31.7071846,38.2928032 C32.0977089,38.6833275 32.0977089,39.3164925 31.7071846,39.7070168 C31.3166603,40.097541 30.6834953,40.097541 30.292971,39.7070168 L26.7635997,36.1776454 C25.6417591,37.0085897 24.2532671,37.5 22.75,37.5 C19.0220779,37.5 16,34.4779221 16,30.75 C16,27.0220779 19.0220779,24 22.75,24 C26.4779221,24 29.5,27.0220779 29.5,30.75 C29.5,32.2531809 29.008646,33.6416 28.1777882,34.7634068 L28.1777882,34.7634068 Z",
    id: "search"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a0450b6d7f66f15a8ab50cf87afaceb9.svg";
export { ForwardRef as ReactComponent };